import { useContext } from "react";
import { NotifierContext } from "App/Notifier";
import { hideLoader, showLoader } from "redux/action/loaderAction";
import { useHistory } from "react-router-dom";
import { useTypedDispatch } from "App/Store";
import { Panel } from "rsuite";
import AddBrandForm from "components/AddBrandForm";
import { addBrand } from "core/services/Brand";

export default function AddBrand() {
  const dispatch = useTypedDispatch();
  const { showNotification } = useContext(NotifierContext);
  const history = useHistory();

  function handleAddBrand(brandData: any) {
    dispatch(showLoader());
    const formData = new FormData();
    Object.entries(brandData).forEach(([key, value]: any) => {
      // Skip empty values so they aren't sent as the string "null"/"undefined"
      // (multipart has no real null) and fail number/array casts on the backend.
      if (value === null || value === undefined) return;
      if (value instanceof File) {
        formData.append(key, value);
      } else if (typeof value === "string") {
        formData.append(key, value);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    });

    addBrand(formData).then((res) => {
      if (res.status) {
        showNotification({
          message: "Brand created successfully",
          title: "Success",
          type: "success",
        });
        history.replace("/store?tab=brands");
      } else {
        showNotification({
          message: res.message || "This brand cannot be created",
          title: "Error",
          type: "error",
        });
      }
      dispatch(hideLoader());
    });
  }

  return (
    <Panel bordered shaded>
      <AddBrandForm onAddBrand={handleAddBrand} isEditMode={false} />
    </Panel>
  );
}
